import { render, staticRenderFns } from "./select-option.vue?vue&type=template&id=681f4bcc&lang=pug"
import script from "./select-option.vue?vue&type=script&lang=js"
export * from "./select-option.vue?vue&type=script&lang=js"
import style0 from "./select-option.vue?vue&type=style&index=0&id=681f4bcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports